<template>
  <fragment>
    <div class="location-search-block__control">
      <!-- Location Search Input Field -->
      <location-search-input       
        :placeholdertext="placeholdertext"
        >
    </location-search-input>
    </div>
  </fragment>
</template>

<script>
import { mapActions } from "vuex";
import Vue from "vue";
import VueMq from "vue-mq";
import LocationSearchInput from "./components/LocationSearchInput.vue";

Vue.use(VueMq, {
  breakpoints: {
    mobile: 678,
    tablet: 992,
    desktop: Infinity
  }
});

export default {
    data() {
    return {
      // zipcode: this.locZip,
      // latitude: this.locLat,
      // longitude: this.locLong,
      //placeholdertext: this.placeholdertext,      
    }
  },
    mounted() {
      // need to check for data here so we can remove the timeout
  },
  components: {
    "location-search-input": LocationSearchInput
  },
    methods: {
      ...mapActions([
      ])//,
      //renderCards() {

      //},
    },
  props: {
    // locLong: String,
    // locLat: String,
    // locZip: String,
    // locType: String,
    placeholdertext: String,
   
  }
};
</script>
